import { useEffect, useState } from 'react'
import { inject, observer } from 'mobx-react';
import FormMaster from '../FormMaster'
import { CommonService } from "../../../services";
import { isEmpty } from 'lodash';
import { useTranslation } from 'react-i18next'

let firstRender = false
const Price = inject("authenStore")(observer((props) => {
  const { t } = useTranslation(['price', 'common'])
  let authenStore = props.authenStore
  let { getAccountAuth } = authenStore // STATE
  let auth = { action_user_id: getAccountAuth?.user_id, token_id: getAccountAuth?.access_token }

  const [masterOptions, setMasterOptions] = useState({
    common_status: [],
    customer: [],
    product_unit: []
  })

  useEffect(() => {
    if (firstRender || !isEmpty(getAccountAuth)) {
      CommonService.getMasterData(auth, "common_status,customer,product_unit")
        .then((res: any) => {
          let common_status = res.result.common_status.map((item) => ({ label: item.status_name, value: item.status_code }))
          let customer = res.result.customer.map((item) => ({ label: item.cust_name, value: item.cust_id }))
          let product_unit = res.result.product_unit.map((item) => ({ label: item.unit_name, value: item.unit_id }))

          setMasterOptions({
            ...masterOptions,
            common_status,
            customer,
            product_unit
          })
        })
        .catch((err) => {
          console.log(`Load master data : ${err}`)
        })
    }
    else
      firstRender = true
  }, [getAccountAuth])

  return <FormMaster
    title={t('transport_price_setting')}
    tableConfig={{
      key: "id",
      apiPath: "price/list",
      allowDelete: {
        visible: true,
        key: "price_id",
        apiPath: "price/delete",
        paramType: "param"
      },
      optionDeleteFag: true,
      defaultColumn: [],
      columns: [
        {
          dataField: 'no',
          caption: t('no'),
          width: 60,
          alignment: "center",
          allowFiltering: false
        },
        {
          dataField: 'cust_name',
          caption: t('customer'),
          allowFiltering: true
        },
        {
          dataField: 'price',
          caption: t('price_per_unit'),
        },
        {
          dataField: 'unit_name',
          caption: t('unit_of_goods'),
          allowFiltering: true
        },
        {
          dataField: 'min_item',
          caption: t('min_quantity'),
        },
        {
          dataField: 'max_item',
          caption: t('max_quantity'),
        },
        {
          dataField: 'active_date',
          caption: t('effective_date'),
          allowFiltering: true
        },
        {
          dataField: 'status_name',
          caption: t('status'),
          allowFiltering: true
        },
        {
          dataField: 'updated_by',
          caption: t('edit_by')
        },
        {
          dataField: 'updated_date',
          caption: t('date_edited'),
        }
      ],
      exportExcel: {
        fileName: t('transport_price_setting'),
        columnConfig: [
          { label: t('no'), value: 'no' },
          { label: t('customer'), value: 'cust_name' },
          { label: t('price_per_unit'), value: 'price' },
          { label: t('unit_of_goods'), value: 'unit_name' },
          { label: t('min_quantity'), value: 'min_item' },
          { label: t('max_quantity'), value: 'max_item' },
          { label: t('effective_date'), value: 'active_date' },
          { label: t('status'), value: 'status_name' },
          { label: t('edit_by'), value: 'updated_by' },
          { label: t('date_edited'), value: 'updated_date' }
        ]
      }
    }}
    formData={{
      cust_id: "",
      price: "",
      unit_id: "",
      max_item: "",
      min_item: "",
      active_date: "",
      status: "Y"
    }}
    modalConfig={{
      screenName: "price",
      visible: true,
      title: t('transport_price_setting'),
      required: ["cust_id", "price", "unit_id", "max_item", "min_item", "active_date"],
      fieldTypeNumber: [],
      paramName: "price_id",
      apiPath: {
        "get": '',
        "post": 'price/add',
        "put": 'price/update'
      },
      elements: [
        {
          fieldName: "cust_id",
          label: t('customer'),
          placeholder: t('customer'),
          inputType: "select",
          required: true,
          options: masterOptions.customer,
          isOneRow: true
        },
        {
          fieldName: "price",
          label: t('price_per_unit'),
          placeholder: t('price_per_unit'),
          required: true,
          inputType: "number",
          isOneRow: true
        },
        {
          fieldName: "min_item",
          label: t('min_quantity'),
          placeholder: t('min_quantity'),
          required: true,
          inputType: "number",
          isOneRow: true
        },
        {
          fieldName: "max_item",
          label: t('max_quantity'),
          placeholder: t('max_quantity'),
          required: true,
          inputType: "number",
          isOneRow: true
        },
        {
          fieldName: "unit_id",
          label: t('unit_of_goods'),
          placeholder: t('unit_of_goods'),
          inputType: "select",
          required: true,
          options: masterOptions.product_unit,
          isOneRow: true
        },

        {
          fieldName: "active_date",
          label: t('effective_date'),
          placeholder: t('effective_date'),
          inputType: "date",
          required: true,
          isOneRow: true
        },
        {
          showSearch: false,
          fieldName: "status",
          label: t('status'),
          inputType: "select",
          defaultValue: "Y",
          options: masterOptions.common_status,
          required: true,
          isOneRow: true
        }
      ]
    }}
  />
}))

export default Price